import { useEffect, useState } from "react"

/**
 * Garde affichée la dernière valeur non nulle pendant `duration` ms après qu'elle
 * soit passée à null, pour laisser le temps à une animation de sortie de se jouer.
 */
export const useExitTransition = <T>(value: T | null, duration: number) => {
  const [displayedValue, setDisplayedValue] = useState<T | null>(value)
  const [isLeaving, setIsLeaving] = useState(false)

  useEffect(() => {
    if (value !== null) {
      setDisplayedValue(value)
      setIsLeaving(false)
      return undefined
    }

    setIsLeaving(true)
    const timeoutId = window.setTimeout(() => {
      setDisplayedValue(null)
      setIsLeaving(false)
    }, duration)
    return () => window.clearTimeout(timeoutId)
  }, [value, duration])

  return { displayedValue, isLeaving }
}
